/* src/app/components/service/service-type-forms/fusion-file-format/fusion-file-format.component.css */
table {
  width: 100%;
}
th,
td {
  padding: 8px;
  text-align: left;
}
/*# sourceMappingURL=fusion-file-format.component.css.map */
